module.exports = __webpack_public_path__ + "fonts/subset-MullerExtraBold.8dd65208.woff2";